import { sortAscending } from "../../../../utility/workbench-utility/Utility";

const initialState = {
  allGroupsData: [],
  groupDataById: {},

  tableLoading: false,
  sidebarLoading: false,
};

const GroupsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "GET_ALL_GROUPS_DATA":
      return {
        ...state,
        allGroupsData: sortAscending(payload, "name"),
      };
    case "GET_GROUP_DATA_BY_ID":
      return {
        ...state,
        groupDataById: sortAscending(payload, "name"),
      };
    case "ADD_GROUP_DATA": {
      const { payload } = action;

      return {
        ...state,
        allGroupsData: sortAscending(
          state.allGroupsData.concat(payload),
          "name"
        ),
      };
    }
    case "UPDATE_GROUP_DATA": {
      const { payload } = action;

      return {
        ...state,
        allGroupsData: sortAscending(
          state.allGroupsData.map((item) =>
            item.id === payload.id ? { ...payload } : item
          ),
          "name"
        ),
      };
    }
    case "DELETE_GROUP_DATA": {
      return {
        ...state,
        allGroupsData: state.allGroupsData.filter(({ id }) => id !== payload),
      };
    }

    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };

    default:
      return state;
  }
};

export default GroupsReducer;
